//DASHBOARD
export const RECEIVE_PROPOSALS = 'RECEIVE_PROPOSALS';
export const RECEIVE_PROPOSAL = 'RECEIVE_PROPOSAL';
export const CREATE_PROPOSAL = 'CREATE_PROPOSAL';
export const REMOVE_PROPOSAL = 'REMOVE_PROPOSAL';

//APP
export const UPDATE_PROJECT_INFO = 'UPDATE_PROJECT_INFO';
export const UPDATE_MILESTONES = 'UPDATE_MILESTONES';

export const ADD_PHASE = 'ADD_PHASE';
export const ADD_CHILD = 'ADD_CHILD';
export const ADD_SIBLING = 'ADD_SIBLING';
export const REMOVE_TILE = 'REMOVE_TILE';
export const SWITCH_WITH_UPPER_SIBLING = 'SWITCH_WITH_UPPER_SIBLING';
export const SWITCH_WITH_LOWER_SIBLING = 'SWITCH_WITH_LOWER_SIBLING';
export const SHIFT_OUT = 'SHIFT_OUT';
export const SHIFT_IN = 'SHIFT_IN';
export const UPDATE_MILESTONE_JSON = 'UPDATE_MILESTONE_JSON';

export const UPDATE_TIME = 'UPDATE_TIME';
export const UPDATE_PRICE = 'UPDATE_PRICE';

export const UPDATE_CONFIRMATION = 'UPDATE_CONFIRMATION';

//CLIENTS
export const RECEIVE_CLIENTS = 'RECEIVE_CLIENTS';
export const SET_CLIENT = 'SET_CLIENT';
export const UPDATE_CLIENT = 'UPDATE_CLIENT';
export const CREATE_CLIENT = 'CREATE_CLIENT';

//COMPANIES
export const RECEIVE_COMPANIES = 'RECEIVE_COMPANIES';
export const CREATE_COMPANY = 'CREATE_COMPANY';
export const UPDATE_COMPANY = 'UPDATE_COMPANY';
export const REMOVE_COMPANY = 'REMOVE_COMPANY';


// WEBPACK FOOTER //
// ./src/store/mutation-types.js